import { GoogleSigninButtonModule } from "@abacritt/angularx-social-login";
import { NgFor, NgIf, isPlatformBrowser } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, signal, ViewChild, WritableSignal } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";
import { first, firstValueFrom, Subscription } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { GfkService } from "src/app/servicios/gfk/gfk.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { PublicidadService } from "../../servicios/publicidad/publicidad.service";
import { EstructuraDefectoComponent } from "./estructura-defecto/estructura-defecto.component";
import { EstructuraSeccionComponent } from "./estructura-seccion/estructura-seccion.component";
import { ReelsService } from "@src/app/servicios/reels.service";
import { Orientation } from "@src/app/models/enums/orientation.enum";
import { PortadaService } from "@src/app/servicios/portada/portada.service";
import { Noticia } from "@src/app/models/interfaces/noticia.interface";
import { CanonicalService } from "@src/app/servicios/canonical/canonical.service";
import { NavbarIframesComponent } from "../navbar-iframes/navbar-iframes.component";
import { SeoService } from "@src/app/servicios/seo/seo.service";
import { ConsentService } from "@src/app/servicios/consent/consent.service";
import { CookieService } from "ngx-cookie-service";
import { environment } from "@src/environments/environment";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  imports: [RouterLink, EstructuraDefectoComponent, EstructuraSeccionComponent, KebabCasePipe, GoogleSigninButtonModule, NgIf, NgFor, NavbarIframesComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit, OnDestroy {
  @Input() showFecha: boolean;
  isMobile: boolean = false;
  isWebView = false; // Indica si se está en una WebView.

  mensajeError = "";
  canales = [];
  videosDirecto: Noticia[] = [];
  publicidad_bloques = {};
  publicidad_divisores_movil = [];
  publicidadCabecera: any;
  publicidadTop: any;
  publicidadOver: any;
  numPubli = 0;
  constantesGlobales: WritableSignal<any>;
  posVideo = 0;
  heightVideo = 0;

  selectorName: any;
  configBloque: any;
  showBloque: any;
  estructuraBySeccion = false;

  @ViewChild("mostrarContenedor") mostrarContenedorIframes: ElementRef<HTMLDivElement>;
  showIframesComponent = false;
  private consentSubscription?: Subscription;

  constructor(
    public readonly router: Router,
    private readonly portadaService: PortadaService,
    private readonly deviceService: DeviceDetectorService,
    private readonly publiService: PublicidadService,
    private readonly elementRef: ElementRef,
    private readonly configService: ConfigService,
    private readonly platformService: PlatformService,
    private readonly gfkService: GfkService,
    private readonly cd: ChangeDetectorRef,
    private readonly reelsService: ReelsService,
    private readonly canonicalService: CanonicalService,
    private readonly consentService: ConsentService,
    private readonly cookieService: CookieService,
    private readonly seoService: SeoService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {
    this.reelsService.setOrientation(Orientation.Clasico);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();

    if (this.isMobile) {
      this.isWebView = this.isInAndroidWebView() || this.isInIOSWebView();
    }
    this.constantesGlobales = signal(this.configService.getConstantesGlobales());
    // ✅ MOVER checkIfTribuna después de que todo esté inicializado
    setTimeout(() => {
      this.checkIfTribuna();
    }, 1000); // Dar tiempo para que se inicialicen los servicios
    //this.checkIfTribuna();
    this.updateMetaTags();
    if (this.constantesGlobales().gfk === true && this.platformService.isBrowser()) {
      this.initGfk();
    }

    this.selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((resultConfig) => {
        if (resultConfig) {
          this.configBloque = resultConfig.general[this.selectorName];
          if (this.configBloque.config_orden_portada_seccion === "true") {
            this.estructuraBySeccion = true;
          }
        }
      });
    }
    if (this.configBloque.has_live_video === "true") {
      firstValueFrom(this.portadaService.getVideosDirecto(1, this.constantesGlobales().idCanalDirecto)).then((result: Noticia[]) => {
        this.videosDirecto = result;
        this.cd.detectChanges();
      });
    }
    this.getPublicidad();
  }
  getPublicidad(): void {
    const publi = this.publiService.getPubli();
    if (publi) {
      publi.pipe(first()).subscribe((result) => {
        if (result != null) {
          let numPubli = 0;
          const arrayPublicidadCabecera = result.imagenes.filter((item) => item.idPosicion === "1");
          numPubli = Math.floor(Math.random() * arrayPublicidadCabecera.length);
          this.publicidadCabecera = arrayPublicidadCabecera[numPubli];

          const arrayPublicidadTop = result.imagenes.filter((item) => item.idPosicion === "49");
          numPubli = Math.floor(Math.random() * arrayPublicidadTop.length);
          this.publicidadTop = arrayPublicidadTop[numPubli];

          const arrayPublicidadOver = result.imagenes.filter((item) => item.idPosicion === "51");
          numPubli = Math.floor(Math.random() * arrayPublicidadOver.length);
          this.publicidadOver = arrayPublicidadOver[numPubli];

          result.imagenes.forEach((currentValue) => {
            if ((currentValue.idPosicion === "27" || currentValue.idPosicion === "28" || currentValue.idPosicion === "29") && (currentValue.id_tipo === "40" || currentValue.id_tipo === "41" || currentValue.id_tipo === "42" || currentValue.id_tipo === "43" || currentValue.id_tipo === "44")) {
              this.publicidad_bloques[currentValue.nombrePosicion.replace("Divisor ", "")] = currentValue;
            }
            if (currentValue.idPosicion === "34" || currentValue.idPosicion === "35" || currentValue.idPosicion === "36" || currentValue.idPosicion === "37" || currentValue.idPosicion === "38" || currentValue.idPosicion === "39" || currentValue.idPosicion === "40" || currentValue.idPosicion === "41" || currentValue.idPosicion === "42" || currentValue.idPosicion === "43" || currentValue.idPosicion === "44" || currentValue.idPosicion === "45" || currentValue.idPosicion === "46" || currentValue.idPosicion === "47" || currentValue.idPosicion === "48") {
              this.publicidad_divisores_movil[currentValue.nombrePosicion.replace("Movil - divisor fila ", "")] = currentValue;
            }
          });
        }
        this.cd.markForCheck();
      });
    }
  }

  /**
   * Actualiza las metaetiquetas de la página con información relevante
   * obtenida de las constantes globales. Estas metaetiquetas incluyen
   * descripciones, títulos, información de Open Graph, y datos de Dublin Core.
   *
   * @private
   */
  private updateMetaTags(): void {
    this.seoService.updateGenericMetaTags({
      title: this.constantesGlobales().siteTitle,
      description: this.constantesGlobales().metaTag,
      url: this.constantesGlobales().siteDomain,
      type: "website",
    });
  }

  private initGfk(): void {
    if (this.constantesGlobales().gfk) {
      const customParams = { c1: this.stripProtocolAndSubdomain(this.constantesGlobales().siteDomain), c2: "homepage" };
      this.gfkService.impression(customParams);
    }
  }

  stripProtocolAndSubdomain(url: string): string {
    const strippedUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");
    return strippedUrl;
  }

  trackItem(index: number, item: any): string {
    return item.id;
  }

  private checkIfTribuna(): void {
    if (!this.platformService.isBrowser()) {
      return;
    }

    const siteDomain = this.constantesGlobales()?.siteDomain || "";
    const isTribuna = siteDomain.includes("tribuna");
    // console.log("🔍 HomeComponent: Verificando si el sitio es Tribuna:", { siteDomain, isTribuna });
    if (!isTribuna) {
      this.showIframesComponent = false;
      return;
    }
    if (this.isMobile || this.isWebView) {
      this.showIframesComponent = false;
      return;
    }

    // En desarrollo/local
    if (!environment.production) {
      this.showIframesComponent = false;
      this.cd.detectChanges();
      return;
    }

    // En producción, suscribirse al ConsentService
    this.consentSubscription = this.consentService.consents.subscribe((consents) => {
      // ✅ Mostramos los iframes del footer solo si se ha aceptado el consentimiento de rendimiento o publicidad
      if (consents && (consents.rendimiento === true || consents.publicidad === true)) {
        this.showIframesComponent = true;
        this.cd.detectChanges();

        // No nos desuscribimos aquí para permitir que se oculten si el usuario cambia el consentimiento (si fuera posible)
      } else {
        this.showIframesComponent = false;
        this.cd.detectChanges();
      }
    });
  }
  isInAndroidWebView(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /; wv/.test(userAgent);
    }
  }
  isInIOSWebView(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = window.navigator.userAgent.toLowerCase();

      const isIOS = /iphone|ipod|ipad/.test(userAgent);
      const notSafari = !/safari/.test(userAgent);
      const notStandalone = !("standalone" in window.navigator && window.navigator["standalone"]);

      return isIOS && notSafari && notStandalone;
    }
  }
  ngOnDestroy(): void {
    if (this.consentSubscription) {
      this.consentSubscription.unsubscribe();
    }
  }
}
